import { Box, Typography } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import BasicTabs from 'components/tabs/basic-tabs/basic-tabs.component'
import TabPanel from 'components/tabs/tab-panel/tab-panel.component'
import ActionButtons from 'components/action-buttons/action-buttons.component'
import { carrierDetailTabs } from 'pages/address/address.constant'
import {
  AddressContext,
  AddressProviderValue,
} from 'pages/address/address.provider'
import { useCarrierList, useSelectedCarrier } from 'pages/address/address.hooks'
import CarrierFormTab from './carrier-form-tab/carrier-form-tab.component'
import CarrierDocumentTab from './carrier-document-tab/carrier-document-tab.component'

const CarrierDetails = () => {
  const { detailTabIndex, setDetailTabIndex } =
    useContext(AddressContext) as AddressProviderValue
  const selectedCarrier = useSelectedCarrier()
  const { refetch } = useCarrierList()

  const [isDirty, setIsDirty] = useState(false)
  const [saveToken, setSaveToken] = useState(0)
  useEffect(() => {
    setDetailTabIndex(0)
    setIsDirty(false)
  }, [selectedCarrier?.carrier.associationId, setDetailTabIndex])

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setDetailTabIndex(newValue)
    setIsDirty(false)
  }

  const handleUpdate = () => {
    setSaveToken((prev) => prev + 1)
  }

  const handleSaved = () => {
    setIsDirty(false)
    refetch()
  }

  if (!selectedCarrier) {
    return (
      <Box p={3}>
        <Typography variant="body2" fontWeight={600}>
          Select a carrier to view details.
        </Typography>
      </Box>
    )
  }

  const tabProps = {
    carrier: selectedCarrier.carrier,
    onDirtyChange: setIsDirty,
    saveToken,
    onSaved: handleSaved,
  }

  const updateDisabled = detailTabIndex !== 0 || !isDirty

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <BasicTabs
          tabs={carrierDetailTabs}
          value={detailTabIndex}
          handleChange={handleTabChange}
          scrollableContent
        >
          <TabPanel value={detailTabIndex} index={0}>
            <CarrierFormTab {...tabProps} />
          </TabPanel>
          <TabPanel value={detailTabIndex} index={1}>
            <CarrierDocumentTab companyId={selectedCarrier.carrier.companyId} />
          </TabPanel>
        </BasicTabs>
      </Box>

      <ActionButtons
        firstBtnProps={{
          title: 'Update',
          onClick: handleUpdate,
          disabled: updateDisabled,
          bgcolor: 'primary.main',
        }}
      />
    </Box>
  )
}

export default CarrierDetails
